import { all, takeEvery, put, call } from 'redux-saga/effects';
import actions from './actions';
import { sendRequest } from '../../../../../helpers/saga';
import { logger } from '../../../../../helpers/logger';
import notifications from '../../../../../redux/notifications/actions';
import Api, { executeAction } from '../../../../../helpers/api';
import jobActions from '../../actions';
import { t } from '../../../../../i18n';

const loadUnlockReasonsApi = new Api('jobs/:id/bookings/auto_pilot_unlock_form_data');
const unlockJobApi = new Api('jobs/:job_id/bookings/:booking_id/unlock_auto_pilot_booking');

function* enableIp(data) {
  try {
    const { method, url, jobId, cb, pages } = data.payload;

    const result = yield call(sendRequest, executeAction, { url, method }, notifications.REQUEST_ERROR);

    if (result && result.data) {
      if (jobId) {
        yield put(jobActions.loadData({ id: jobId, pages }));
      }
      yield put(
        notifications.addNotification({
          headline: t('dash.common.notification.success_headline'),
          type: 'success',
          message: t('dash.common.notification.successfully_enabled', { item: 'IP' }),
        }),
      );

      if (cb) {
        cb();
      }
    }
  } catch (error) {
    logger.error(error);
  }
}

function* disableIp(data) {
  try {
    const { method, url, jobId, cb, pages } = data.payload;

    const result = yield call(sendRequest, executeAction, { url, method }, notifications.REQUEST_ERROR);

    if (result && result.data) {
      if (jobId) {
        yield put(jobActions.loadData({ id: jobId, pages }));
      }
      yield put(
        notifications.addNotification({
          headline: t('dash.common.notification.success_headline'),
          type: 'success',
          message: t('dash.common.notification.successfully_disabled', { item: 'IP' }),
        }),
      );

      if (cb) {
        cb();
      }
    }
  } catch (error) {
    logger.error(error);
  }
}

function* sendShiftRequest({ payload }) {
  try {
    const { url, method, jobId, cb, pages } = payload;
    const result = yield call(sendRequest, executeAction, { url, method }, notifications.REQUEST_ERROR);

    if (result && (result.messages || result.success)) {
      if (jobId) {
        yield put(jobActions.loadData({ id: jobId, pages }));
      }
      yield put(
        notifications.addNotification({
          headline: t('dash.common.notification.success_headline'),
          type: 'success',
          message: result.messages.join(' '),
        }),
      );

      if (cb) {
        cb();
      }
    }
  } catch (error) {
    logger.error(error);
  }
}

function* activateBackup(data) {
  try {
    const { method, url, jobId, cb, pages } = data.payload;

    const result = yield call(sendRequest, executeAction, { url, method }, notifications.REQUEST_ERROR);

    if (result && result.data) {
      if (jobId) {
        yield put(jobActions.loadData({ id: jobId, pages }));
      }
      yield put(
        notifications.addNotification({
          headline: t('dash.common.notification.success_headline'),
          type: 'success',
          message: t('dash.common.notification.activated_successfully', { item: t('dash.jobs.bookings.backup_label') }),
        }),
      );

      if (cb) {
        cb();
      }
    }
  } catch (error) {
    logger.error(error);
  }
}

function* removeShift(request) {
  try {
    const { method, url, jobId, cb, pages, data } = request.payload;

    const result = yield call(sendRequest, executeAction, { url, method, data }, notifications.REQUEST_ERROR);

    if (result && result.data) {
      if (jobId) {
        yield put(jobActions.loadData({ id: jobId, pages }));
      }
      yield put(
        notifications.addNotification({
          headline: t('dash.common.notification.success_headline'),
          type: 'success',
          message: t('dash.common.notification.removed_successfully', { item: t('dash.jobs.bookings.worker_label') }),
        }),
      );

      if (cb) {
        cb();
      }
    }
  } catch (error) {
    logger.error(error);
  }
}

function* unlockBookingRequest(payload) {
  const { jobId, bookingId, reason, description, cb, pages } = payload.payload;

  try {
    const result = yield call(
      sendRequest,
      unlockJobApi.multipleParamsCreateItem,
      { data: { reason, description }, params: { job_id: jobId, booking_id: bookingId } },
      notifications.REQUEST_ERROR,
    );

    if (result) {
      yield put(actions.closeBookingUnlockModal());

      if (jobId) {
        yield put(jobActions.loadData({ id: jobId, pages }));
      }

      if (cb) {
        cb();
      }
    }
  } catch (error) {
    yield put(notifications.REQUEST_ERROR);
    logger.error(error);
  }
}

function* getUnlockReasonsRequest(payload) {
  const { jobId } = payload.payload;

  try {
    const result = yield call(sendRequest, loadUnlockReasonsApi.load, { id: jobId }, notifications.REQUEST_ERROR);

    if (result && result.data) {
      const { data } = result;
      yield put(actions.getUnlockReasonsSuccess(data));
    }
  } catch (error) {
    yield put(notifications.REQUEST_ERROR);
    logger.error(error);
  }
}

export {
  enableIp,
  disableIp,
  activateBackup,
  removeShift,
  sendShiftRequest,
  unlockBookingRequest,
  getUnlockReasonsRequest,
};

export default function* rootSaga() {
  yield all([
    takeEvery(actions.ENABLE_IP, enableIp),
    takeEvery(actions.DISABLE_IP, disableIp),
    takeEvery(actions.ACTIVATE_BACKUP, activateBackup),
    takeEvery(actions.REMOVE_SHIFT, removeShift),
    takeEvery(actions.SEND_REQUEST, sendShiftRequest),
    takeEvery(actions.UNLOCK_BOOKING_REQUEST, unlockBookingRequest),
    takeEvery(actions.GET_UNLOCK_REASONS_REQUEST, getUnlockReasonsRequest),
  ]);
}
